import type { App } from 'vue';

export default function trimZvdZO(input?: string): string {
  return input ? input.replace(/\s*[([]\s*ZvdZ-?O[)\]]/g, '') : '';
}

export const Plugin = {
  install(app: App<Element>) {
    app.mixin({
      methods: { trimZvdZO },
    });
  },
};

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    trimZvdZO: (input?: string) => string;
  }
}
